function e(n) {
  window.openNativeDialog(n);
}
function i() {
  window.closeNativeDialog();
}
function o(n) {
  window.executeOnOriginPage(n);
}
function t(n) {
  window.openDeeplink(n);
}
function a() {
  return typeof window.openNativeDialog == "function";
}
function u() {
  return typeof window.executeOnOriginPage == "function";
}
export {
  i as closeNativeDialog,
  o as executeOnOriginPage,
  u as isInBottomSheet,
  a as isNativeDialogSupported,
  t as openDeeplink,
  e as openNativeDialog
};
